import type { MeDto } from '@hudhuria/shared';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { meQuery } from '~/api/queries';
import { ApiError } from '~/lib/api';
import { signInPath } from '~/lib/entry';
import { session } from '~/session/session';

/**
 * Signed-in area. Uses the cached profile when there is one, so the app opens offline;
 * only a first launch on this device needs the network.
 */
export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ context }) => {
    if (!session.get().token) throw redirect({ to: signInPath() });
    let me = context.queryClient.getQueryData<MeDto>(meQuery.queryKey);
    if (!me) {
      try {
        me = await context.queryClient.fetchQuery({ ...meQuery, retry: false });
      } catch (e) {
        if (e instanceof ApiError && e.status === 401) {
          session.expire();
          throw redirect({ to: signInPath() });
        }
        throw e;
      }
    }
    if (session.needsCenter(me)) throw redirect({ to: '/center' });
    return { me };
  },
  component: Outlet,
});
